import React from 'react';
import './shared.css';
import Footer from './Footer';
import TopNav from './TopNav';

function TermsOfUse() {
  return (
    <div className="min-h-screen w-full bg-gray-50">
      {/* Top Navigation */}
      <TopNav />

      {/* Header Section */}
      <div className="App-header" style={{ background: '#1f2937', minHeight: '20vh' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '1rem', textAlign: 'center' }}>
          Terms of Use
        </h1>
      </div>

      {/* Main Content */}
      <div className="responsive-px" style={{ paddingTop: '2rem', paddingBottom: '2rem', maxWidth: '900px', margin: '0 auto' }}>
        <div style={{ fontSize: '1rem', lineHeight: 1.8, color: '#374151' }}>
          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>1. Acceptance of Terms</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            By accessing and using PotatoPapers, you agree to be bound by these terms. If you do not agree, please do not use this site.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>2. Educational Use Only</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            This site is intended for educational purposes only. Users must comply with all applicable laws and their institution's academic integrity policies.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>3. Intellectual Property</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            All past papers, mark schemes, examiner reports, threshold data are owned by Cambridge Assessment International Education and Pearson Edexcel. PotatoPapers does not own, create, or claim ownership of this content. This site is an aggregator only.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>4. No Affiliation</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            PotatoPapers is not affiliated with, endorsed by, or connected to CAIE, Edexcel, Cambridge Assessment, or Pearson. We are an independent student resource.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>5. Limitation of Liability</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            PotatoPapers is provided on an "as-is" basis. We do not warrant the accuracy, completeness, or usefulness of any content. We are not liable for any damages arising from the use or inability to use this site, including but not limited to educational outcomes, grades, or academic performance.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>6. External Content</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            We link to YouTube videos created by external content creators. We do not control, endorse, or assume responsibility for external content. Please verify solutions independently and check official mark schemes.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>7. Prohibited Use</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            Users must not:
          </p>
          <ul style={{ marginLeft: '1.5rem', marginBottom: '1.5rem', gap: '0.5rem', display: 'flex', flexDirection: 'column' }}>
            <li>• Violate academic integrity rules at their institution</li>
            <li>• Reproduce or distribute content in violation of copyright laws</li>
            <li>• Use automated tools to scrape or harvest content</li>
            <li>• Attempt to reverse-engineer or modify site functionality</li>
          </ul>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>8. Modification of Terms</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            We reserve the right to modify these terms at any time. Continued use of the site constitutes acceptance of updated terms.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>9. Governing Law</h2>
          <p>
            These terms are governed by applicable law. Any disputes shall be resolved through appropriate legal channels.
          </p>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default TermsOfUse;
